import React, { useEffect } from "react";
import "../assets/css/cxda.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";

import member1 from "../assets/g-team.jpeg";
import member2 from "../assets/g-team2.jpeg";
import member3 from "../assets/g-team3.jpeg";
import member4 from "../assets/g-team4.jpg";

const teamMembers = [
  {
    name: "Thierry Porte",
    role: "Co-founder & Chairman",
    img: member1,
  },
  {
    name: "Lina Hediah",
    role: "Co-founder & CEO",
    img: member2,
  },
  {
    name: "Gregory E Smith",
    role: "Co-founder & Director",
    img: member3,
  },
  {
    name: "Anupam Gupta",
    role: "Director of Programs",
    img: member4,
  },
];

const Globalteam = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);
  return (
    <section className="oman-team-section pt-2" data-aos="fade-up">
      <div className="container">
        <h2 className="text-center fw-bold mb-4 text-danger">Global Team</h2>

        <div className="row text-center">
          {teamMembers.map((member, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3 mb-4">
              <div className="team-card p-4">
                <img
                  src={member.img}
                  alt={member.name}
                  className="rounded-circle mb-3 team-img"
                />
                <h5 className="fw-bold  mb-2">{member.name}</h5>
                <p className=" mb-0">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Globalteam;
